/**
 * Fetch result content reducer.
 * 
 * @param  {String} state  The initial state.
 * @param  {String} action The action to perform. 
 * @return {Object}
 */
export default function ( state = '', action )
{
	switch ( action.type )
	{
		default:
			return state;
	}
}